import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Content } from '../../../components/Content';
import { HBox, VBox } from '../../../components/Box';
import { FormField, FormFields } from '../../../components/FormFields';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { Button } from '../../../components/Buttons';
import { WorkflowProductsOverviewTable } from '../components/WorkflowProductsOverviewTable';
import _ from 'lodash';
import {
  addWorkflowProduct,
  createWorkflow,
  fetchWorkflow,
  updateWorkflow,
  addWorkflowTask,
  updateWorkflowTask,
  deleteWorkflowTask,
} from '../actions';
import { selectConfig, selectWorks } from '../../Api/selectors';
import {
  REQUEST_ADD_WORKFLOW_PRODUCT,
  REQUEST_CREATE_WORKFLOW,
  REQUEST_FETCH_WORKFLOW_PRODUCT,
  REQUEST_UPDATE_WORKFLOW_PRODUCT,
  REQUEST_WORKFLOW,
  WORKFLOW_STATUSES,
} from '../constants';
import { Loader } from '../../../components/Loader';
import { fetchAllProducts } from '../../products/actions';
import { selectProducts } from '../../products/selectors';
import { REQUEST_PRODUCTS } from '../../products/constants';
import { WorkflowTasksSection } from '../components/WorkflowTasksSection';
import { WORKFLOW_CRUD } from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { addWorkflowToCompany } from '../../Companies/actions';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './details.module.css';

const Container = styled.div`
  .nav-link {
    cursor: pointer;
  }
  .nav-link.active {
    color: blue;
  }
  .basic-multi-select {
    width: 100%;
    max-width: 100%;
  }

  .col {
    width: 100%;
  }
  .col-main {
    padding-right: 48px;
  }

  .formField {
    margin-bottom: 12px;
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .field-block {
    width: 50%;
  }
  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin-right: 6px;
    }
    .col {
      @media (max-width: 768px) {
        width: 100%;
        min-width: 200px;
      }
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

const STATE = {
  showAddProductModal: false,
};

class WorkflowDetailsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  componentDidMount() {
    // if (this.props.workflow_id) this.props.fetch();
    this.props.fetchAvailableProducts();
  }

  componentDidUpdate(prevProps, prevState) {}

  get availableProducts() {
    // const added = this.workflowProducts.map(i => i.product.id);
    // return this.props.availableProducts.filter(i => !added.includes(i.id));

    // The product may be added multiple times with different vehicle_purpose
    return this.props.availableProducts;
  }

  get productOptions() {
    return this.availableProducts.map(p => {
      return { value: p.id, label: p.name };
    });
  }

  get newProduct() {
    return this.state?.newProduct;
  }

  get newTask() {
    return this.state?.newTask;
  }

  get workflow() {
    return this.props.workflow;
  }

  get workflowProducts() {
    return this.workflow?.products ?? [];
  }

  get tasks() {
    return this.workflow?.tasks ?? [];
  }

  getFieldValue(name) {
    if (!this.props.workflow_id) return this.state[name];
    if (!this.workflow) return null;
    return this.state[name] !== undefined ? this.state[name] : this.workflow[name];
  }

  get status() {
    const value = this.getFieldValue('status');
    if (Object.values(WORKFLOW_STATUSES).includes(value)) return value;
    return WORKFLOW_STATUSES.OPEN;
  }

  onStringInputChange(evt) {
    this.updateState(evt.target.name, evt.target.value);
  }

  setNewProduct(e) {
    const { value } = e;
    const product = this.productOptions.find(p => p.value === value);
    this.setState({ newProduct: product });
  }

  onClickAddNewProduct() {
    this.setState({ showAddProductModal: true });
  }

  onNewProductInputChanged(evt) {
    const name = evt.target.name;
    const value = evt.target.value;
    this.setState(prev => ({ newProduct: { ...prev.newProduct, [name]: value } }));
  }

  get newProductQuantity() {
    return this.state.newProduct?.quantity ?? 1;
  }

  get newProductPurpose() {
    return this.state.newProduct?.vehiclePurpose ?? '';
  }

  addNewProduct() {
    const dto = {
      productId: this.newProduct?.value,
      quantity: +this.state.newProduct?.quantity || 1,
      vehiclePurpose: this.state.newProduct?.vehiclePurpose ?? null,
    };
    this.props.addWorkflowProduct(dto, this.onCloseAddNewProductModal.bind(this));
  }

  onCloseAddNewProductModal() {
    this.setState({ showAddProductModal: false, newProduct: null });
  }

  setVehiclePurposeForNewRecord(evt) {
    const value = evt.value;
    this.setState(prev => ({ ...prev, newProduct: { ...prev.newProduct, vehiclePurpose: value } }));
  }

  get onClickAddNewProductDisabled() {
    return !this.newProduct?.value || this.isFinal;
  }

  get availableVehiclePurposes() {
    const fromConfig = (this.props.config?.configJSON?.vehicle_purposes ?? []).map(p => p.vehicle_purpose);
    const defaultPurposes = [
      'passenger',
      'commercial',
      'Trekker',
      'Bakwagen',
      'Oplegger',
      'Aanhangwagen',
      'Landbouw- of bosbouwtrekker',
      'Motorfiets' ,
      'Bromfiets',
      'Klein materieel (binnenopslag) per m2',
      'Klein/middelgroot materieel buitenopslag <6m2',
      'Groot & afwijkend materieel buitenopslag >6m2',
      'chassiscabine_less_3500',
      'chassiscabine_greater_3500',
      'motor',
      'oplegger',
      'aanhanger',
    ];

    // TODO refactor return only fromConfig after IDWE-2829 merged
    return fromConfig.length ? fromConfig : defaultPurposes;
  }

  get vehiclePurposesOptions() {
    return this.availableVehiclePurposes.map(purpose => ({ value: purpose, label: purpose }));
  }

  renderAddNewProductModal() {
    if (!this.state.showAddProductModal) return;

    return (
      <ModalComponent
        onClose={this.onCloseAddNewProductModal.bind(this)}
        title={this.lbl(`workflows.details.addProductModalTitle`)}
      >
        <FormFields>
          <VBox>
            <FormField label={this.lbl('workflows.productDetails.quantity')}>
              <input
                className="form-control"
                name="quantity"
                value={this.newProductQuantity}
                onChange={this.onNewProductInputChanged.bind(this)}
              />
            </FormField>
            <FormField label={this.lbl('workflows.productDetails.vehiclePurpose')}>
              <div className="w-100">
                <SearchSelect
                  options={this.vehiclePurposesOptions}
                  value={{ label: this.newProductPurpose }}
                  onChange={this.setVehiclePurposeForNewRecord.bind(this)}
                />
              </div>
            </FormField>
          </VBox>
        </FormFields>

        <div className={styles.buttonContainer}>
          <div className={styles.rowButtonsWrapper}>
            <ButtonComponent style={'ButtonSoftDelete'} onClick={this.onCloseAddNewProductModal.bind(this)}>
              {this.lbl(`cancel`)}
            </ButtonComponent>
            <ButtonComponent style={'ButtonSoftEdit'} type="submit" onClick={this.addNewProduct.bind(this)}>
              {this.lbl(`confirm`)}/{' '}
            </ButtonComponent>
          </div>
        </div>
      </ModalComponent>
    );
  }

  onClickAddNewTask() {
    this.props.addWorkflowTask({ name: this.newTask, vehiclePurposes: ['*'] });
    this.setState({ newTask: null });
  }

  get onClickAddNewTaskDisabled() {
    return !this.newTask || this.tasks.includes(this.newTask) || this.isFinal;
  }

  editTask(id, dto) {
    this.props.updateWorkflowTask(id, dto);
  }

  get isFinal() {
    return this.workflow?.status === WORKFLOW_STATUSES.FINAL;
  }

  renderFieldsForExistingWorkflow() {
    if (!this.workflow?.id) return;

    return (
      <div className="container-fluid p-0">
        <HBox left className="field-block">
          <FormField label={this.lbl('workflows.details.selectProductTitle')}>
            <HBox>
              <SearchSelect
                value={this.newProduct}
                options={this.productOptions}
                onChange={this.setNewProduct.bind(this)}

              />
              <Button small onClick={this.onClickAddNewProduct.bind(this)} >
                {this.lbl('workflows.details.addNewProductBtn')}
              </Button>
            </HBox>
          </FormField>
        </HBox>
        <HBox>
          <WorkflowProductsOverviewTable
            workflowProducts={this.workflowProducts}
            workflow={this.workflow}
            workflowDisabled={this.isFinal}
          />
        </HBox>
        <HBox left className="field-block">
          <FormField label={this.lbl('workflows.details.tasksSectionTitle')}>
            <HBox vCenter>
              <input
                className="form-control"
                name={'newTask'}
                value={this.getFieldValue('newTask')}
                onChange={this.onStringInputChange.bind(this)}
           
              />
              <Button small onClick={this.onClickAddNewTask.bind(this)} >
                {this.lbl('workflows.details.addNewProductBtn')}
              </Button>
            </HBox>
          </FormField>
        </HBox>
        <HBox>
        <WorkflowTasksSection
            tasks={this.tasks}
            editTask={this.editTask.bind(this)}
            removeTask={this.props.deleteWorkflowTask.bind(this)}
            disabled={this.isFinal}
          />
        </HBox>
        {this.renderAddNewProductModal()}
      </div>
    );
  }
  reset() {
    this.setState(prev => ({ ...STATE }));
  }

  get saveDisabled() {
    return !this.getFieldValue('name') || !this.getFieldValue('nameOnInvoice') || this.isFinal;
  }

  onSave() {
    const dto = {
      name: this.getFieldValue('name'),
      nameOnInvoice: this.getFieldValue('nameOnInvoice'),
    };
    if (!this.props.workflow_id) {
      this.props.create(dto, result => {
        this.reset();

        if (result.id) this.to(`/workflows/${result.id}`);
      });
    }

    if (this.props.workflow_id && this.props.editCompanyId) {
      this.props.update(dto, result => {
        if (result?.success) {
          this.props.addWorkflowToCompany(this.props.workflow_id, res => {
            if (res?.success) {
              this.to(`/companies/${this.props.editCompanyId}/edit/1`);
            }
          });
        }
      });
      return;
    }

    if (this.props.workflow_id) {
      this.props.update(dto);
    }
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Permission permission={WORKFLOW_CRUD}>
        <Container>
          <div className="info-card">
            <Content>
              <Wrapper>
                <VBox left className="col col-main">
                  <HBox left className="field-block">
                    <FormField label={this.lbl('workflows.details.name')}>
                      <input
                        className="form-control"
                        name={'name'}
                        value={this.getFieldValue('name')}
                        onChange={this.onStringInputChange.bind(this)}
                      />
                    </FormField>
                  </HBox>
                  <HBox left className="field-block">
                    <FormField label={this.lbl('workflows.details.nameOnInvoice')}>
                      <input
                        name={'nameOnInvoice'}
                        className="form-control"
                        value={this.getFieldValue('nameOnInvoice')}
                        onChange={this.onStringInputChange.bind(this)}
                        required={true}
                        disabled={this.isFinal}
                      />
                    </FormField>
                  </HBox>
                  <HBox left className="field-block">
                    <FormField label={this.lbl('workflows.details.status')}>
                      <p>{this.lbl(`workflows.details.status.${this.status}`)}</p>
                    </FormField>
                  </HBox>
                  {this.workflow?.id && this.renderFieldsForExistingWorkflow()}
                </VBox>
              </Wrapper>

              <HBox right>
                <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
                  {this.lbl('workflows.details.resetBtn')}
                </ButtonComponent>
                <ButtonComponent style={'ButtonSoftEdit'}  onClick={this.onSave.bind(this)}>
                  {this.lbl('workflows.details.saveBtn')}
                </ButtonComponent>
              </HBox>
            </Content>
          </div>
        </Container>
      </Permission>
    );
  }
}

WorkflowDetailsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    // workflow: selectWorkflow(ownProps.workflow_id),
    work: selectWorks([
      REQUEST_WORKFLOW,
      REQUEST_CREATE_WORKFLOW,
      REQUEST_PRODUCTS,
      REQUEST_ADD_WORKFLOW_PRODUCT,
      REQUEST_UPDATE_WORKFLOW_PRODUCT,
    ]),
    availableProducts: selectProducts(),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    create(dto, callback) {
      dispatch(createWorkflow(dto, callback));
    },
    fetch() {
      dispatch(fetchWorkflow(ownProps.workflow_id));
    },
    update(dto, callback) {
      dispatch(updateWorkflow(ownProps.workflow_id, dto, callback));
    },
    fetchAvailableProducts() {
      dispatch(fetchAllProducts());
    },
    addWorkflowProduct(dto, callback) {
      dispatch(addWorkflowProduct(ownProps.workflow_id, dto, callback));
    },
    addWorkflowToCompany(workflowId, callback) {
      dispatch(addWorkflowToCompany(ownProps.editCompanyId, workflowId, callback));
    },
    addWorkflowTask(dto) {
      dispatch(addWorkflowTask(ownProps.workflow_id, dto));
    },
    updateWorkflowTask(taskId, dto) {
      dispatch(updateWorkflowTask(ownProps.workflow_id, taskId, dto));
    },
    deleteWorkflowTask(taskId) {
      dispatch(deleteWorkflowTask(ownProps.workflow_id, taskId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export const WorkflowDetailsColumns = compose(withConnect, withRouter)(WorkflowDetailsColumnsComp);
